import React, { useState, useRef, useEffect } from 'react'

import classNames from 'classnames'

import styles from './icon_card_grid.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'
import Button from './basic/button'
import Counter from './misc/counter'
import Video from './basic/video'

function IconCardGrid(props) {
	const videoComponentRefs = useRef([])
	const fields = props.fields
	const [items, setItems] = useState(fields.items.map(obj => ({ ...obj, buttonActive: false })))
	const [modalOpen, setModalOpen] = useState(false)
	const [activeVideoIndex, setActiveVideoIndex] = useState(null)

	const handleMouseEvent = (index) => {
		setItems(
			items.map(
				(item, itemIndex) => itemIndex === index ? { ...item, buttonActive: true } : { ...item, buttonActive: false }
			)
		)
	}

	const handleClick = (index) => {
		if(items[index].modal.call_to_action){
			toggleVideoModal(index)
			return
		}

		if(items[index].button.url){
			window.location = items[index].button.url
		}
	}

	const toggleVideoModal = (index) => {
		setModalOpen(!modalOpen)
		document.body.classList.toggle('overlay_open')
		
		if (modalOpen) {
			// Close modal - pause the active video
			if (videoComponentRefs.current[activeVideoIndex]) {
				videoComponentRefs.current[activeVideoIndex].pause()
			}
			// Hide all video modals
			videoComponentRefs.current.forEach((_, i) => {
				const videoModal = document.querySelector(`[data-video-modal="${i}"]`)
				if (videoModal) {
					videoModal.style.display = 'none'
				}
			})
			setActiveVideoIndex(null)
		} else {
			// Open modal
			setActiveVideoIndex(index)
			if (videoComponentRefs.current[index]) {
				videoComponentRefs.current[index].play()
			}
		}
	}

	useEffect(() => {
        if (activeVideoIndex !== null && modalOpen) {
			const videoModal = document.querySelector(`[data-video-modal="${activeVideoIndex}"]`)
			if (videoModal && window.innerWidth > 768) {
				videoModal.style.display = 'block'
			}
        }
    }, [activeVideoIndex, modalOpen])

	const handleModalClick = (e) => {
		e.stopPropagation()
		toggleVideoModal()
	};
	
	const handleModalInnerClick = (e) => {
		e.stopPropagation()
	}

	return <BlockWrapper {...props} className={classNames(styles.icon_card_grid, styles[fields.style], props.tabbed_content ? styles.tabbed_content : '')}>
	<ScrollAnimation styles={styles}>
		<div className={classNames(styles.grid_wrapper, styles[`columns_${fields.items.length}`])}>

				{items && items.map((item, i) => {
					return <div key={i} className={classNames(styles.grid_item)}
						onMouseEnter={() => handleMouseEvent(i)}
						onMouseLeave={() => handleMouseEvent()}
						onClick={() => handleClick(i)} >
						{item.include_badge &&
							<div className={styles.badge_wrapper}>
								<p className={styles.badge}>Covered by Medicare</p>
							</div>
						}
						{item.icon.url && <Image className={styles.icon} {...item.icon} />}
						<div className={styles.content_wrapper}>
							{item.statistic && 
								<div className={styles.counter}>
									<Counter end={item.statistic} repeat={false} seconds={.5} delay={Math.random() * .2} />
								</div>
							}
							<h3 className={classNames(styles.heading, item.heading_color == 'green' ? styles.green : '')} dangerouslySetInnerHTML={{ __html: item.heading }}></h3>
							<div className={styles.content} dangerouslySetInnerHTML={{__html: item.content}}></div>
							{item.button?.url && 
								<Button className={styles.button} fields={{button: item.button}} button_style={item.button_style} color={fields.style == 'style_4' ? 'white' : item.button_color} active={item.buttonActive}>{item.button.title}</Button>
							}
							{item?.modal.call_to_action &&
								<Button className={styles.button} active={item.buttonActive} color={'white'} button_style={'style_1'}>{item.modal.call_to_action}</Button>
							}
						</div>
					</div>
				})}
			</div>
		</ScrollAnimation>

		<div className={classNames(styles.video_modal, modalOpen ? styles.open : '')} onClick={handleModalClick}>
			<div className={styles.video_modal_inner} onClick={handleModalInnerClick}>
				<div className={styles.video_modal_close} onClick={() => {toggleVideoModal()}}></div>
					{items && items.map((item, i) => {
						if(!item.modal.video) return null

						return <div key={i} data-video-modal={i} className={styles.video_modal_video} style={{display: 'none'}}>
							<Video ref={el => videoComponentRefs.current[i] = el} modalOpen={modalOpen} isVideoPopUp={true} settings={{playsinline: false, autoplay: false}} captions={fields.captions ? fields.captions.url : undefined} {...item.modal.video} />
						</div>
					})}
			</div>
		</div>
	</BlockWrapper>
}

export default IconCardGrid